import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Divider,
  Avatar,
  Autocomplete,
  Box
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import './ContactCard.css';

const ContactCard = ({
  mission,
  utilisateur,
  editable,
  onChange,
  users = []
}) => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const avatarSrc = utilisateur?.photo ? `${API_BASE}${utilisateur.photo}` : '';

  // Cherche le user sélectionné selon mail+nom
  const selectedUser = users.find(
    (u) => u.email === mission.email && u.nom === mission.nom
  ) || null;

  // Callback quand on sélectionne un user
  const handleUserChange = (e, user) => {
    if (user) {
      onChange && onChange('nom', user.nom);
      onChange && onChange('email', user.email);
      onChange && onChange('telephone', user.telephone);
    }
  };

  const handlePhoneChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) {
      onChange && onChange("telephone", inputValue);
    }
  };
function getInitials(nomComplet = "") {
  // Trim, split, enlève espaces doubles
  const mots = nomComplet.trim().split(/\s+/);
  if (mots.length === 0) return "U";
  if (mots.length === 1) return mots[0][0].toUpperCase();
  return (mots[0][0] + mots[mots.length - 1][0]).toUpperCase();
}

  return (
    <Card className="contact-card-modern">
      <CardContent>
        <div className="contact-avatar-container">
<Avatar
  key={mission.nom} // force le re-render si mission.nom change
  src={avatarSrc}
  alt={mission.nom}
  className="contact-avatar-img"
>
  {getInitials(mission.nom)}
</Avatar>



          <Typography variant="h6" className="contact-name">
            {mission.nom}
          </Typography>
          <Typography variant="body2" className="contact-role">
            {mission.role}
          </Typography>
        </div>

        <Divider className="contact-divider-modern" />

        <Typography variant="subtitle1" className="contact-heading">
          Coordonnées
        </Typography>

        {editable ? (
          <Box className="contact-inputs-modern">
            {/* Sélecteur d'utilisateur */}
            <Autocomplete
              options={users}
              getOptionLabel={option => option.nom ? `${option.nom} (${option.email})` : ''}
              value={selectedUser}
              onChange={handleUserChange}
              isOptionEqualToValue={(option, value) => option.email === value.email}
              noOptionsText="Aucun utilisateur trouvé"
              renderInput={(params) => (
                <TextField {...params} label="Responsable à notifier" size="small" fullWidth />
              )}
              className="contact-user-autocomplete"
            />
            <TextField
              label="Email"
              value={mission.email}
              fullWidth
              size="small"
              disabled
              variant="outlined"
              className="contact-field"
            />
            <TextField
              label="Téléphone"
              value={mission.telephone}
              onChange={handlePhoneChange}
              fullWidth
              size="small"
              type="tel"
              className="contact-field"
            />
          </Box>
        ) : (
          <div className="contact-info-modern">
            <div className="contact-line-modern">
              <EmailIcon fontSize="small" className="contact-icon" />
              <Typography variant="body2">{mission.email}</Typography>
            </div>
            <div className="contact-line-modern">
              <PhoneIcon fontSize="small" className="contact-icon" />
              <Typography variant="body2">{mission.telephone}</Typography>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ContactCard;
